const EditUser = (state = false, action) => {
   switch (action.type) {
      case "EDIT_USER":
         return !state ? true : false;
      case "USER_DETAILS":
         return state = false;
      default:
         return state;
   }
};

export default EditUser;
